import React from 'react';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import SurveyStepFooter from 'Views/Onboarding/Pages/Survey/SurveyStep/SurveyStepFooter';
import { addQuery, QueryVal, removeQuery } from 'Helpers/Query';
import { welcomeFlow } from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingWelcome/welcomeFlow';
import InfoScreen from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingWelcome/InfoScreen';
import PicklistDemoInfoScreen from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingWelcome/PicklistDemoInfoScreen';
import { useSurveyContext } from 'Views/Onboarding/Pages/Survey/SurveyContext';
import { useOnboardingHeaderContext } from 'Views/Onboarding/Contexts/OnboardingHeaderContext';

const styles = (theme) => ({
  root: {},
  text: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  textField: {
    marginBottom: theme.spacing(2),
  },
  photoUpload: {
    marginBottom: theme.spacing(1),
  },
  footer: {},
});

function OnboardingWelcomeLayout({
  classes,
}) {
  const { onboardingStepCollection } = useSurveyContext();
  const { onSubmit: onSubmitMetaForm } = useMetaLayoutContext();
  const {
    handleSetNavIconHighlight,
    handleSetChatIconHighlight,
  } = useOnboardingHeaderContext();
  const welcomeStep = QueryVal('welcomeStep');

  const [activeStepIndex, setActiveStepIndex] = React.useState(parseInt(welcomeStep, 10) || 0);
  const onPrevious = (activeStepIndex > 0) ? () => setActiveStepIndex(prev => prev - 1) : null;

  React.useEffect(() => {
    if (activeStepIndex >= 0 && activeStepIndex < welcomeFlow.length) {
      addQuery({ welcomeStep: activeStepIndex });
    }
  }, [activeStepIndex]);

  React.useEffect(() => {
    // Set the appropriate header bar icon highlights
    const step = welcomeFlow[activeStepIndex];
    handleSetNavIconHighlight(step.navIconHighlighted);
    handleSetChatIconHighlight(step.chatIconHighlighted);

    // Turn off header icon highlight on cleanup
    return () => {
      handleSetNavIconHighlight(false);
      handleSetChatIconHighlight(false);
    };
  }, [activeStepIndex]);

  const activeStep = welcomeFlow[activeStepIndex];
  const lastStepIndex = welcomeFlow.length - 1;

  return (
    <div className={classes.root}>
      {activeStep.type === 'picklist'
        ? <PicklistDemoInfoScreen {...activeStep} />
        : <InfoScreen {...activeStep} />}
      {/* ---------- Footer (Navigator) ---------- */}
      <SurveyStepFooter
        className={classes.footer}
        onSubmit={activeStepIndex === lastStepIndex
          ? () => {
            removeQuery('welcomeStep');
            return onSubmitMetaForm();
          }
          : () => {
            setActiveStepIndex(prev => prev + 1);
            return onboardingStepCollection;
          }}
        onPrevious={onPrevious}
        NextButtonProps={{
          buttonLabel: activeStep.nextButtonLabel,
        }}
      />
    </div>
  );
}

OnboardingWelcomeLayout.propTypes = {
  classes: PropTypes.object.isRequired,
};

OnboardingWelcomeLayout.defaultProps = {
};

export default withStyles(styles)(OnboardingWelcomeLayout);
